import { Type } from '@angular/core';
import { MatSort } from '@angular/material/sort';

import { IColumn } from '../../interfaces/column.table';
import { RenderData } from '../../interfaces/render-data';
import { ITotal } from '../../interfaces/total.table';
import { TextItemRendererComponent } from '../../item-renderer/item-renderers/text-item-renderer/text-item-renderer.component';

export class TextColumn<T> implements IColumn<T> {
  header: string;
  sortField: string;
  renderer: Type<any>;
  total: ITotal<T>;
  renderData: RenderData;
  sortFunction?: (data: T[], sort: MatSort) => T[];

  constructor(
    header: string,
    value: (item: T) => any,
    sortField?: string,
    total?: ITotal<T>,
    renderData?: RenderData,
    sortFunc?: (data: T[], sort: MatSort) => T[]
  ) {
    this.header = header;
    this.sortField = sortField;
    this.value = value;
    this.renderer = TextItemRendererComponent;
    this.total = total;
    this.sortFunction = sortFunc;

    if (renderData && renderData.width) {
      this.renderData = renderData;
    } else {
      this.renderData = new RenderData();
    }
  }

  value(item: any): any {}
}
